import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_SCHEMA}://${process.env.VUE_APP_BACKEND_HOST}`,
});

export default axiosInstance;
